import { render, staticRenderFns } from "./worddoc.vue?vue&type=template&id=afb21552&scoped=true&"
import script from "./worddoc.vue?vue&type=script&lang=js&"
export * from "./worddoc.vue?vue&type=script&lang=js&"
import style0 from "./worddoc.vue?vue&type=style&index=0&id=afb21552&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb21552",
  null
  
)

export default component.exports